$(document).ready(function () {  

  $(".LN000008 .multi_coll > .colitem > .sub-list").each(function(){
    var _h =  $(".gnb_col3 .multi_coll").height();
    $(this).css({ "min-height" : "auto" });
    $(this).css({ "min-height" : _h });
  }); 

  $(".LN000008 .gnb_hover > li > a ").hover(function(){ 
    var _h =  $(".gnb_col3 .multi_coll").height();
    $(".sub-list", this).css({ "min-height" : "auto" });
    $(".sub-list", this).css({ "min-height" : _h });
  });



  // dep1 hover 
  $(".menu-list > li").hover(function($e){
    var _hoverIndex =  $(this).index();    
    $(".multi_coll > .colitem").removeClass("dep1_hover");
    $(".multi_coll > .colitem").eq(_hoverIndex).addClass("dep1_hover");
  }, function(){    
    //$(".multi_coll > .colitem").delay(10).removeClass("dep1_hover");
  })
  
    // dep2 hover
  $(".menu_dep1 .multi_coll > .colitem").hover(function($e){
    var _hoverIndex =  $(this).index();
    $(".menu_dep1  .menu-list > li").eq(_hoverIndex).addClass("hover");

    $(".multi_coll > .colitem").removeClass("dep1_hover");
    $(this).addClass("hover");
  }, function(){
    $(".menu_dep1  .menu-list > li").removeClass("hover");
    $(this).removeClass("hover");
  });

  // dep3 hover
  $(".menu_dep1 .menu_dep3").hover( function(){
    $(this).closest("li").addClass("on");
  }, function(){
    $(this).closest("li").removeClass("on");
  });

  // dep3 item hover
  $(".menu_dep3.dep3_bg .sub-list > li").hover( function(){
    var _dep3_id = $(this).attr("data-index");	
    $(".menu_dep2 > .sub-list > li[data-index="+_dep3_id+"]").addClass("on");
    subHeight();
  },function(){
    $(".menu_dep2 > .sub-list > li").removeClass("on");
  });

  function subHeight(){
    if($(".multi_coll").innerHeight() < $(".menu_dep3.dep3_bg > .sub-list").innerHeight()){
      $(".multi_coll").height( $(".menu_dep3.dep3_bg > .sub-list").innerHeight() );
    }
    console.log( $(".multi_coll").height(),  $(".menu_dep3.dep3_bg > .sub-list").innerHeight());
  }
  
  subHeight();


  
  /* ========== sticky ============ 라벨 */
  // sticky 
  if( $(".sticky-wrap .labelscroll-area").length ){
    $('.labelscroll-area .mCustomScrollbar_x').mCustomScrollbar({autoHideScrollbar: true, axis:'x',advanced:{autoExpandHorizontalScroll:true}});
  }


/*   $(window).resize(function(){
    scrollLabelOnOff();    /// 스크롤 라벨 
  })
  
  // 타이어 검색, 스티키바 
  function scrollLabelOnOff(){ 
    $(".labelscroll-area .scroll-inner").each( function(){
      $(this).hasScrollBar(); // ture of false
    }) 
  }
  $.fn.hasScrollBar = function() { 
    // 스크롤 있는지 여부 판단
    var _B =  (this.prop("scrollWidth") == 0 && this.prop("clientWidth") == 0)
    || (this.prop("scrollWidth") > this.prop("clientWidth"));
    _B ? $(this).closest(".labelscroll-area").addClass("scroll_on") : $(this).closest(".labelscroll-area").removeClass("scroll_on");
    return _B
    
  };
  $(".labelscroll-area .scroll-inner").hasScrollBar();
   */


})//ready



function makeTireSearchSelect_lang($this, data, $lang)
{      
	var t = $($this),
		parent = t.data('parent'),
		labeltxt = $('label[for='+parent+']').text(),		
		orival,oridata,reset= false;
	var footer = footer ? true : false;

	if (t.hasClass("select2-hidden-accessible")) {
		// Select2 has been initialized
		// data 미리 보관
		orival = t.val();
		oridata = t.data('data');
		/// console.log(oridata);
		t.select2("destroy");
		reset = true;
	}

	var options = {
		width:'100%',
		minimumResultsForSearch: Infinity,
		dropdownParent: t.closest('.select-box'),
		closeOnSelect: false,
		dropdownPosition:'below',
		//dropdownCssClass:'fixed_dropdown',
		escapeMarkup: function (markup) { return markup; },
		language: {
			noResults: function(){
				return '<p><i class="icon-search_empty"></i>'+ $lang +'</p>';
			}
		},
		tags:true
	};
	if( $('body').hasClass('is_mb') || footer ) {
		// mobile 일 경우, select2 기본값을 변경함
		options.dropdownCssClass = '';
		options.dropdownPosition = '';
		options.closeOnSelect = true;
		options.placeholder = Josa.r(labeltxt,'을/를')+' 선택해주세요.';

		if( footer ) options.dropdownParent= $(document.body);
	}

	
	if( data ) {
		options.data = data;
		t.data('data', data);
		if( data[0] && data[0].icon ) {
			options.templateResult = formatOption
		}
	} else if( oridata && reset ) {
		options.data = oridata;
		if( oridata[0] && oridata[0].icon ) {
			options.templateResult = formatOption
		}
	}

	var list = t.select2(options);
	if( $('body').hasClass('is_pc') && footer == false ) { 
		// pc 일 경우 select2 동작을 막음.
		list.on("select2:closing", function(e) {
			e.preventDefault();
		}).on("select2:closed", function(e) {
			list.select2("open");
		});
		list.select2("open"); 
	} else {
		list.off("select2:closing").off("select2:closed");
		list.select2("close"); 
	}
	t.closest('.select-box').find('.select2-results__options').mCustomScrollbar();
	// option 갯수가 없으면 tire_option-empty class 추가
	if( list.find('option').length == 0 ) t.closest('.select-box').addClass('tire_option-empty');
	else t.closest('.select-box').removeClass('tire_option-empty');

	if( orival ) t.val(orival).trigger("change");
}